/** @format — Collapsed sidebar "d" mark (design: 11×20) */

import React from "react";

export default function SidebarCollapsedLogo({ className = "" }) {
  return (
    <svg
      width={11}
      height={20}
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`h-5 w-[11px] flex-shrink-0 flex-grow-0 ${className}`}
      preserveAspectRatio="xMidYMid meet"
      aria-hidden
    >
      <g clipPath="url(#clip0_sidebar_collapsed_logo)">
        <path
          d="M6.03735 15.1382H56.0468L58.6788 18.1H3.40527L6.03735 15.1382Z"
          fill="#87B1FE"
        />
        <path
          d="M11.4633 16.7246H8.13741V15.902C7.87985 16.1271 7.59162 16.3245 7.27266 16.4942C6.66662 16.8015 5.99405 16.955 5.25498 16.955C4.23503 16.955 3.32591 16.7016 2.52769 16.1948C1.74425 15.688 1.12345 14.9969 0.665214 14.1215C0.221764 13.2461 2.48292e-06 12.2478 0 11.1267C0 10.0056 0.221759 9.00733 0.665214 8.13192C1.12345 7.25654 1.74426 6.56541 2.52769 6.05861C3.32591 5.55181 4.23503 5.29846 5.25498 5.29846C5.99405 5.29846 6.65921 5.44432 7.25047 5.7361C7.55122 5.88091 7.82473 6.05408 8.07089 6.25562V0H11.4633V16.7246ZM5.8758 8.47749C5.40279 8.47749 4.9815 8.59267 4.61195 8.82304C4.2572 9.0534 3.96895 9.36826 3.74722 9.76754C3.54028 10.1668 3.43681 10.6199 3.43681 11.1267C3.43681 11.6335 3.54028 12.0866 3.74722 12.4859C3.95417 12.8851 4.24241 13.2 4.61195 13.4304C4.98149 13.6607 5.39538 13.7759 5.85361 13.7759C6.34141 13.7759 6.76269 13.6684 7.11745 13.4534C7.4722 13.223 7.75304 12.9082 7.96003 12.5089C8.16695 12.1096 8.27045 11.6489 8.27045 11.1267C8.27045 10.6046 8.16695 10.1514 7.96003 9.76754C7.76783 9.36826 7.48699 9.0534 7.11745 8.82304C6.76269 8.59267 6.34881 8.47749 5.8758 8.47749Z"
          fill="#1637E1"
        />
        <path d="M58.6788 18.1001H3.40527V19.9101H58.6788V18.1001Z" fill="#1637E1" />
      </g>
      <defs>
        <clipPath id="clip0_sidebar_collapsed_logo">
          <rect width={11} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
